<template>
    <div>
        <v-container>
            <v-form>
                <v-row class="px-8">
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text"
                            ref="pmassessmentrecordcode" :rules="[rules.required]" @input="updateValue"
                            v-model="formData.pmassessmentrecordcode" dense 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text"
                            ref="pmassessmentrecorddesc" :rules="[rules.required]"
                            v-model="formData.pmassessmentrecorddesc" @input="updateValue" dense 
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentstartdate')" type="date" ref="startdate"
                            :rules="[rules.required]" v-model="formData.startdate" @input="updateValue"
                            @change="updateValue" dense 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentenddate')" type="date" ref="enddate"
                            :rules="[rules.required]" v-model="formData.enddate" @input="updateValue"
                            @change="updateValue" dense 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcutoffdate')" type="date" ref="cutoffdate"
                            :rules="[rules.required]" v-model="formData.cutoffdate" @input="updateValue"
                            @change="updateValue" dense 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8"> 
                        <v-autocomplete outlined :label="$t('columns.status')" type="text" ref="statusid"
                            :rules="[rules.required]" v-model="formData.statusid" dense :items="statusList"
                            @input="updateValue"
                            class="v-input"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="false"><!-- hide for now, we just do rank first , also need to take from table pmasseratingtype--> 
                    <v-col cols="8" class="pb-n5 mt-n6">
                        <v-radio-group v-model="formData.ratingtype" row 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        >
                            <v-radio label="Rank" value=1></v-radio>
                            <v-radio label="Grid" value=2></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('pmassementrecord.pmassessmentratingoption')" type="text" ref="ratingid"
                            :rules="[rules.required]" v-model="formData.ratingid" dense :items="ratingOptionList"
                            @input="updateValue" @change="changeRatingOption(formData.ratingid)" 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentratingcode')" type="text" v-model="formData.ratingcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('columns.remark')" type="text" ref="remark" v-model="formData.remark" dense
                            rows="1"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" class="pb-n5 mt-n6">
                        <v-autocomplete outlined :label="$t('pmassementrecord.pmassessmentcalculationmethod')" type="text" ref="pmassecalmethodid"
                            :rules="[rules.required]" v-model="formData.pmassecalmethodid" dense :items="calMethodList"
                            @input="updateValue" 
                            class="v-input" :readonly="isEdit" 
                            :background-color="isEdit ? '#ffeab2' : ''"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <app-formbuttons 
                    v-on:SavePressed="saveHandler"
                    v-on:CancelPressed="cancelHandler" 
                />
                <v-row v-if="isEdit">
                    <v-col cols="6" sm="6" class="blue--text">
                        {{ $t('appraisalrecord.reviews') }}
                    </v-col>
                </v-row>
                <v-row v-if="isEdit && formData.startdate != null" >
                    <app-table
                        v-bind:parentObject="{
                            tabHeader: this.tabHeader,
                            detailItem: this.parentObject.pmAssessmentRecordReviewList,
                            pmassessmentrecordid: this.parentObject.data.id,
                            startdate: this.formData.startdate,
                            enddate: this.formData.enddate,
                            pmassecalmethodid: this.formData.pmassecalmethodid,//if pass id=1 ,percentage, then show percentage column to input
                            pmassecalmethodname: this.formData.pmassecalmethodname,
                        }"
                        v-on:input="addItemHandler"
                    />
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from "./CRUDTable";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-table": CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                pmassessmentrecordcode: this.parentObject.data.pmassessmentrecordcode,
                pmassessmentrecorddesc: this.parentObject.data.pmassessmentrecorddesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                cutoffdate: this.parentObject.data.cutoffdate,
                statusid: this.parentObject.data.statusid,
                // ratingtype: this.parentObject.data.ratingtype,
                ratingtype: 1,//hardcoded 1 first, 1 = rank || 2 = grid, will change later
                ratingid: this.parentObject.data.ratingid,
                ratingcode: this.parentObject.data.ratingcode,
                remark: this.parentObject.data.remark,
                pmassecalmethodid: this.parentObject.data.pmassecalmethodid,
                pmassecalmethodname: this.parentObject.data.calculationmethodname, 
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
            },

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '150px', sortable: false},
                { text: this.$t('pmassementrecord.reviewexercisecode'), value: 'reviewcode', width: '150px', sortable: false},
                { text: this.$t('performancereport.reviewexercisedescription'), value: 'reviewdesc', width: '250px', sortable: false },
                { text: "%", value: 'percentage', width: '20px', sortable: false },
                { text: this.$t('pmassementrecord.reviewexerciseperiodfrom'), value: 'startdate', width: '150px', sortable: false },
                { text: this.$t('pmassementrecord.reviewexerciseperioduntil'), value: 'enddate', width: '150px', sortable: false},
            ],

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
            ratingOptionList: [], // take necessary data only from Full
            ratingOptionFull: [],// get full data from database
            calMethodList: [],
            calMethodFull: [],
            statusList:[],
            statusFull:[],
        }
    },

    methods: {
        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({ name: 'performanceassessmentrecordlist' });
        },

        addItemHandler($event) {
            this.formData.pmassessmentrecordreview = $event;
            this.updateValue();
        },

        updateValue() {
            this.$emit('input', {
                pmassessmentrecordcode: this.formData.pmassessmentrecordcode,
                pmassessmentrecorddesc: this.formData.pmassessmentrecorddesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                cutoffdate: this.formData.cutoffdate,
                statusid: this.formData.statusid,
                ratingtype: this.formData.ratingtype,
                ratingid: this.formData.ratingid,
                ratingcode: this.formData.ratingcode,
                remark: this.formData.remark,
                pmassecalmethodid: this.formData.pmassecalmethodid,
                pmassecalmethodname: this.formData.pmassecalmethodname, 
                stamp: this.formData.stamp,
                userid: this.formData.userid,
                pmassessmentrecordreview: this.formData.pmassessmentrecordreview,
            });
        },

        async loadRankMappingListHandler() {//we doing rank map set first, grid will be do later
            const vm = this; 
            this.$store.dispatch('get', { url: '/rankmapset/active/all' })//get isdisable=0 rank mapping set
                .then((res) => {
                    vm.ratingOptionFull = res.data.rec;
                    vm.ratingOptionList = []; // Clear the list before pushing new items

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.ratingOptionList.push({
                            text: res.data.rec[i].description,
                            value: res.data.rec[i].id,
                        });
                    }

                    if (vm.formData.ratingid) {
                        // Manually trigger the change handler to update ratingcode
                        vm.changeRatingOption(vm.formData.ratingid);
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        changeRatingOption(id) {
            let item = this.ratingOptionFull.find((item) => item.id === id);
            this.formData.ratingcode = item.rankmapset;
            //this is use to get rank mapping list
            //will add on another condition to get grid
        },

        async loadPmAsseStatusListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/pmassementstatus/all' })
                .then((res) => {
                    vm.statusFill = res.data.rec;
                    vm.statusList = []; // Clear the list before pushing new items

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.statusList.push({
                            text: res.data.rec[i].statusdesc,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        async loadCalMethodListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/pmasscalmethod/all' })
                .then((res) => {
                    vm.calMethodFull = res.data.rec;
                    vm.calMethodList = []; // Clear the list before pushing new items

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.calMethodList.push({
                            text: res.data.rec[i].calculationname,
                            value: res.data.rec[i].id,

                            //id 1 = Percentage, 2= Time weighted average
                        });
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

    },
    async mounted() {
        try {
            await this.loadRankMappingListHandler();
            await this.loadPmAsseStatusListHandler();
            await this.loadCalMethodListHandler();
        
        } catch (error) {
            console.error("Error loading data:", error);
        }
    }

}
</script>
